import type { ComponentType } from 'preact';
import type { LucideProps } from 'lucide-preact';
import { signal } from '@preact/signals';

export interface CommandAction {
  id: string;
  label: string;
  hint?: string;
  icon?: ComponentType<LucideProps>;
  group?: string;
  keywords?: string[];
  shortcut?: string;
  perform: () => void | Promise<void>;
}

export const isPaletteOpen = signal(false);
export const paletteActions = signal<CommandAction[]>([]);
export const searchResults = signal<CommandAction[]>([]);

export function setSearchResults(results: CommandAction[]): void {
  searchResults.value = results;
}

export function clearSearchResults(): void {
  searchResults.value = [];
}

export function openPalette() {
  isPaletteOpen.value = true;
}

export function closePalette() {
  isPaletteOpen.value = false;
}

export function togglePalette() {
  isPaletteOpen.value = !isPaletteOpen.value;
}

/**
 * Register a list of actions. Returns an unregister function. Typical usage:
 *   useEffect(() => registerActions([...]), []);
 */
export function registerActions(actions: CommandAction[]): () => void {
  paletteActions.value = [...paletteActions.value, ...actions];
  return () => {
    const ids = new Set(actions.map((a) => a.id));
    paletteActions.value = paletteActions.value.filter((a) => !ids.has(a.id));
  };
}
